import React, { useEffect ,useState} from "react";
import FaqHelpSupport from "./component";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
const FaqTopicsConatiner=(props)=>{
     const { makeApiRequest } = useApiRequest()
  const navigate=useNavigate()
const [orderhistory,setOrderhistory]=useState('')
const [loader,setLoader]=useState(true);
const [topicList,setTopicList]=useState([])


useEffect(()=>{
    fetchfaqTopics()
    fetchOrderHistory()
},[])



const fetchOrderHistory = () => {
  setLoader(true)
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  


   makeApiRequest({
    
        url: `${process.env.REACT_APP_API_BASE_URL}/order/order/orderhistory`,
     method: "POST",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
        },
        data:{
    
        request:{}


      },
      handleSuccess: (res) => handleResponseOrderHistory(res),
      handleError:(error)=> handleErrorOrderHistory(error),
    });


  };
  
  
  const handleErrorOrderHistory=(error)=>{
    
setLoader(false)
  }
  
  const handleResponseOrderHistory=(res)=>{
    //logger.log("handleResponseOrderHistory",res.data.response)
   setLoader(false)
   setOrderhistory(res.data.response)
  }


    const fetchfaqTopics = () => {
        const UserJWTAuth = localStorage.getItem("UserJWTAuth");




   makeApiRequest({
      
        url: `${process.env.REACT_APP_API_BASE_URL}/support/api/v2/faq/topics`,
      method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
        },
        data:{
    
        request:{}


      },
      handleSuccess: (res) => handleResponseFaqTopic(res),
      handleError:(error)=> handleErrorFaqTopic(error),
    });


      };
      
      
      const handleErrorFaqTopic=(error)=>{
        //logger.log("res")
        setLoader(false)
        if(error.response.status==401 || error.response.status==403){

          //logger.log("khan handleErrorVmInventory", error.response.data.status.code);
          //Logout
          //localStorage.removeItem("UserJWTAuth")
            navigate("/login");
      }
      else{ toast.error(`${error.response.data.status.code}`, {
        position: "top-right",
        autoClose: 1000,
      });
      }
        
      }
      
      const handleResponseFaqTopic=(res)=>{
        //logger.log("handleResponseFaqTopic-------",res.data.data
        
        setLoader(false)
        setTopicList(res.data.data)
      }
      const FaqDetailsApi=(e,topicId)=>{

        //logger.log("topicId",topicId)
        navigate(`/faqDetails/${topicId}`)

        

      }

    return(
      
        <FaqHelpSupport
        topicList={topicList}
        FaqDetailsApi={FaqDetailsApi}
        orderhistory={orderhistory}
        loader={loader}
        
        />
        
    )
}

export default FaqTopicsConatiner
